/** Presentation-safe helpers for Places photos already cached by Stasht. */

const STASHT_MEDIA_HOSTS = new Set([
  'd1k4z5if38476e.cloudfront.net',
  'dy9hvwrek2.execute-api.us-east-1.amazonaws.com',
]);

export function isStashtHostedPhotoUrl(value: unknown): value is string {
  if (typeof value !== 'string' || !value.trim()) return false;
  try {
    const url = new URL(value.trim());
    const host = url.hostname.toLowerCase();
    return (
      url.protocol === 'https:'
      && (
        host === 'stasht.app'
        || host.endsWith('.stasht.app')
        || STASHT_MEDIA_HOSTS.has(host)
      )
    );
  } catch {
    return false;
  }
}

export function getStoredPlacePhotoUrl(photo: unknown): string | undefined {
  if (isStashtHostedPhotoUrl(photo)) return photo.trim();
  if (!photo || typeof photo !== 'object') return undefined;
  const record = photo as Record<string, unknown>;
  for (const key of ['url', 'photo_url', 'photo_uri', 'photoUri']) {
    const value = record[key];
    if (isStashtHostedPhotoUrl(value)) return value.trim();
  }
  return undefined;
}
